import { ScopeOption } from '../types';

const protectCopyScope: ScopeOption[] = [
  { value: 'true', label: 'Включена', description: 'Запрет копирования, печати (Ctrl+C, Ctrl+P) и размытие экрана при потере фокуса', badgeColor: '#ef4444' },
  { value: 'none', label: 'Выключена', description: 'Без ограничений копирования и фокуса', badgeColor: '#6b7280' }
];

const mathBool = (allowDesc: string, denyDesc: string): ScopeOption[] => [
  { value: 'true', label: 'Разрешено', description: allowDesc, badgeColor: '#10b981' },
  { value: 'none', label: 'Запрещено', description: denyDesc, badgeColor: '#ef4444' }
];

const mathScopedView = (allowDesc: string, denyDesc: string): ScopeOption[] => [
  { value: 'all', label: 'Вся сеть аптек', description: `${allowDesc}: по всем аптекам`, badgeColor: '#10b981' },
  { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: `${allowDesc}: только закрепленные точки (myPharmacy)`, badgeColor: '#3b82f6' },
  { value: 'own_region', label: 'Свой регион', description: `${allowDesc}: аптеки своего города (cityId)`, badgeColor: '#06b6d4' },
  { value: 'none', label: 'Запрещено', description: denyDesc, badgeColor: '#ef4444' }
];

/**
 * Варианты скоупов для модуля «Отчеты и аналитика» (reports.*)
 */
export const reportsScopes: Record<string, ScopeOption[]> = {
  // Навигация (Пункт №1 по GEMINI.md)
  'reports.menu': [
    { value: 'true', label: 'Включено', description: 'Отображать раздел «Отчеты» в боковом меню', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключено', description: 'Раздел скрыт из бокового меню', badgeColor: '#ef4444' }
  ],

  // Мониторинг сдачи отчетов (Заполнение)
  'reports.fill_monitoring': [
    { value: 'all', label: 'Вся сеть аптек', description: 'Мониторинг заполнения по всем филиалам', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Только курируемые точки (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Подраздел мониторинга скрыт', badgeColor: '#ef4444' }
  ],

  // Ввод даты в мониторинге сдачи отчетов
  'reports.fill_monitoring.date_limit': [
    { value: 'any', label: 'Любое число', description: 'Выбор любой даты в календаре без ограничений', badgeColor: '#10b981' },
    { value: 'yesterday', label: 'Только последний день', description: 'Только вчера (текущий день - 1)', badgeColor: '#f59e0b' },
    { value: 'none', label: 'Запрещено', description: 'Выбор даты заблокирован', badgeColor: '#ef4444' }
  ],
  'reports.fill_monitoring.protect_copy': protectCopyScope,

  // Редактирование дневного отчета
  'reports.edit_daily': [
    { value: 'all', label: 'Вся сеть аптек', description: 'Корректировка данных по всем филиалам', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Правки только по закрепленным точкам (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Правки только по своему городу (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Редактирование дневных отчетов запрещено', badgeColor: '#ef4444' }
  ],

  // Ввод даты в дневном отчете
  'reports.edit_daily.date_limit': [
    { value: 'any', label: 'Любое число', description: 'Выбор любой даты в календаре без ограничений', badgeColor: '#10b981' },
    { value: 'yesterday', label: 'Только последний день', description: 'Только вчера (текущий день - 1)', badgeColor: '#f59e0b' }
  ],
  'reports.edit_daily.protect_copy': protectCopyScope,

  // Редактирование месячного отчета (шахматка)
  'reports.edit_monthly': [
    { value: 'all', label: 'Вся сеть аптек', description: 'Правка месячной шахматки по всем филиалам', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Правка шахматки только своих точек (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Правка шахматки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Редактирование месячных отчетов запрещено', badgeColor: '#ef4444' }
  ],

  // Ввод месяца в месячном отчете
  'reports.edit_monthly.date_limit': [
    { value: 'any', label: 'Любой месяц', description: 'Выбор любого месяца без ограничений', badgeColor: '#10b981' },
    { value: 'last_month', label: 'Только последний месяц', description: 'Только предыдущий месяц (текущий месяц - 1)', badgeColor: '#f59e0b' }
  ],
  'reports.edit_monthly.protect_copy': protectCopyScope,

  // Сводный отчет за период (Отчет)
  'reports.view_summary': [
    { value: 'all', label: 'Вся сеть аптек', description: 'Сводные данные по всем филиалам', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Только закрепленные точки (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Сводный отчет недоступен', badgeColor: '#ef4444' }
  ],

  // Выгрузка в Excel (кнопки EXCEL и custom)
  'reports.view_summary.excel_export': [
    { value: 'true', label: 'Разрешено', description: 'Кнопки экспорта в Excel (EXCEL и Custom)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Экспорт в Excel заблокирован', badgeColor: '#ef4444' }
  ],

  // Отчет по кассе
  'reports.view_summary.cash_report': [
    { value: 'true', label: 'Разрешено', description: 'Формирование и просмотр отчета по кассе', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Отчет по кассе скрыт', badgeColor: '#ef4444' }
  ],

  // Отчет по банку
  'reports.view_summary.bank_report': [
    { value: 'true', label: 'Разрешено', description: 'Формирование и просмотр отчета по банку', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Отчет по банку скрыт', badgeColor: '#ef4444' }
  ],
  'reports.view_summary.protect_copy': protectCopyScope,

  // Директорский отчет (Дир. отчет - просто включить/выключить)
  'reports.view_director': [
    { value: 'true', label: 'Разрешено', description: 'Доступ к управленческой сводке по подчиненным аптекам', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Директорский отчет недоступен', badgeColor: '#ef4444' }
  ],

  // Выгрузка в Excel для Директорского отчета
  'reports.view_director.excel_export': [
    { value: 'true', label: 'Разрешено', description: 'Выгрузка в Excel (Excel общ и Excel аптеки)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Выгрузка в Excel заблокирована', badgeColor: '#ef4444' }
  ],
  'reports.view_director.protect_copy': protectCopyScope,

  // Сверка доставок (модуль Доставка)
  'reports.delivery.view': [
    { value: 'true', label: 'Разрешено', description: 'Доступ к модулю сопоставления файлов доставок', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Модуль сверки доставки недоступен', badgeColor: '#ef4444' }
  ],

  // Управление городами и терминалами доставки
  'reports.delivery.manage_terminals': [
    { value: 'true', label: 'Разрешено', description: 'Управление привязкой городов и терминалов доставки', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Настройка терминалов заблокирована', badgeColor: '#ef4444' }
  ],
  'reports.delivery.protect_copy': protectCopyScope,

  // ─── Мат. отчет ─────────────────────────────────────────────
  // Вход в раздел (Пункт №1)
  'reports.math.view': [
    { value: 'true', label: 'Разрешено', description: 'Раздел «Мат. отчет» доступен (пункт в меню Отчетов)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Раздел «Мат. отчет» скрыт', badgeColor: '#ef4444' }
  ],

  // Вкладка «Отчет»
  'reports.math.report.view': mathScopedView('Просмотр таблицы мат. отчета по аптекам', 'Вкладка «Отчет» скрыта'),
  'reports.math.report.edit_cells': mathBool('Редактирование значений ячеек (только для полей, помеченных как редактируемые)', 'Ячейки только для чтения'),
  'reports.math.report.check_status': mathBool('Установка и снятие статуса проверки аптеки', 'Статус проверки менять нельзя'),
  'reports.math.report.create': mathBool('Создание записей мат. отчета за выбранный месяц', 'Создание записей запрещено'),
  'reports.math.report.reindex': mathBool('Перепроверка (переиндексация) записей за месяц', 'Перепроверка запрещена'),
  'reports.math.report.recalculate': mathBool('Пересчет остатков, начиная с выбранного месяца', 'Пересчет запрещен'),
  'reports.math.report.download': mathBool('Скачивание мат. отчета по аптеке', 'Скачивание запрещено'),

  // Вкладка «Изменения»
  'reports.math.changes.view': mathScopedView('Просмотр аптек с неподтвержденными изменениями', 'Вкладка «Изменения» скрыта'),
  'reports.math.changes.mark_checked': mathBool('Отметка отдельной записи как проверенной', 'Отметка записей запрещена'),
  'reports.math.changes.mark_all': mathBool('Массовая отметка всех записей за месяц', 'Массовая отметка запрещена'),
  'reports.math.changes.copy_whatsapp': mathBool('Копирование текста-напоминания для WhatsApp', 'Копирование текста запрещено'),

  // Вкладка «Отображение»
  'reports.math.fields.view': mathBool('Просмотр списка полей мат. отчета', 'Вкладка «Отображение» скрыта'),
  'reports.math.fields.create': mathBool('Добавление новых полей мат. отчета', 'Добавление полей запрещено'),
  'reports.math.fields.edit': mathBool('Изменение заголовков и признака редактируемости полей', 'Редактирование полей запрещено'),
  'reports.math.fields.delete': mathBool('Удаление полей мат. отчета', 'Удаление полей запрещено'),

  'reports.math.protect_copy': protectCopyScope,

  // ─── История изменений (кнопка «История» на экранах отчетности) ───
  // Включение кнопки (Пункт №1 набора)
  'reports.history.view': [
    { value: 'true', label: 'Включена', description: 'Кнопка «История» на экранах «Редактирование», «Ред. мес. отчет», «Мат. отчет» и «Сверка доставок»', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключена', description: 'Кнопка «История» скрыта', badgeColor: '#ef4444' }
  ],
  'reports.history.pharmacies': [
    { value: 'all', label: 'Вся сеть аптек', description: 'История по всем аптекам, включая правки полей и пересчеты мат. отчета (они без аптеки)', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'История только по закрепленным точкам (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'История по аптекам своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'История пуста', badgeColor: '#ef4444' }
  ],
  'reports.history.details': mathBool('Показывает «было → стало» и снимки удаленных данных', 'В истории виден только список: кто, когда и что сделал')
};
